import Asset from './Asset';
import IAsset from './IAsset'

export default abstract class UserAsset extends Asset implements IAsset {
}
